'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * Prefix prepended to every in-workspace route. Empty string for the
 * Telegram miniapp (routes live at /trends, /feed, …) and `/app` for the
 * web cabinet (routes live at /app/trends, /app/feed, …).
 */
const BasePathContext = createContext<string>('');

export function BasePathProvider({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}) {
  return <BasePathContext.Provider value={value}>{children}</BasePathContext.Provider>;
}

export function useBasePath(): string {
  return useContext(BasePathContext);
}

/**
 * Build an absolute in-app href. Input is the "logical" path (as miniapp
 * knows it): leading slash required. Output is `${base}${path}`, collapsing
 * a trailing slash when the caller passes `/`.
 */
export function useLocalHref(path: string): string {
  const base = useBasePath();
  if (!path.startsWith('/')) return `${base}/${path}`;
  if (path === '/') return base || '/';
  return `${base}${path}`;
}
